$(document).ready(function(){
    var slickConfig = function(){
        var slideCount = getCurrentBreakpoint() == 'desktop' ? 3 : (getCurrentBreakpoint() == 'tablet' ? 2 : 1);
        return {
            arrows: false,
            dots: true,
            infinite: true,
            slidesToShow: slideCount,
            slidesToScroll: slideCount,
        }
    }

    var initializeSlick = function($self, $slider){
        if($slider.is('[cca--reset-instance="1"]')){
            $slider.removeClass('cca--initialized').slick('unslick');
        }

        if(!$slider.hasClass('cca--initialized')){
            $slider.slick(slickConfig()).addClass('cca--initialized');
            //clamp text
            $.each($slider.find('.article-box, .resources-box'), function (i, el) { 
                window.clampText($(el));
            });
            $self.trigger('cca:set-wrapper-height');
        }
        $slider.slick('setPosition');
    }

    var InitializeCards = function($self, $activeTab){
        $.each($activeTab.find('.card-carousel-wrapper'), function (i, el) {
            var $slider = $(el);
            initializeSlick($self, $slider);
        });
    }

    var setSlidesToBeReInitialized = function($tabsContent){
        $.each($tabsContent.find('.card-carousel-wrapper'), function (i, el) {
            $(el).attr('cca--reset-instance', '1');
        });
    }

    var getCurrentBreakpoint = function(){
        var result = '';
        if($(window).width() > 1024){
            result = 'desktop';
        }else{
            if($(window).width() <= 640){
                result = 'mobile';
            }else{
                result = 'tablet';
            }
        }

        return result;
    }
    
    var reorderElementsForResponsive = function($tabsLi, $tabs, $tabsWrapper, currentBreakpoint){
        $tabsWrapper.css('order', '');
        $tabsLi.css('order', '');

        if(currentBreakpoint !== 'desktop'){
            var $activeTab = $tabs.filter('.active');
            var activeTabIndex = parseInt($activeTab.attr('data-tab-index'));

            $.each($tabs, function (i, el) { 
                $(el).parent().css('order', '-' +($tabs.length - i));
            });
            $tabsWrapper.css('order', '-'+($tabs.length - activeTabIndex));
        }
    }

    var scrollToSelectedTabPositionResponsive = function($tabs, currentBreakpoint){
        if(currentBreakpoint !== 'desktop'){
            $("html, body").animate({scrollTop: $tabs.filter('.active').offset().top - 15}, 100);
        }
    }

	$('.process-tabs-container').each(function(){
        var $self = $(this);
        var $tabsLi = $self.find('.tabs-title-wrapper > li');
        var $tabs = $tabsLi.find('> .tab-title'); //data-tab-index
        var $tabsWrapper = $self.find('.tabs-content-wrapper');
        var $tabsContent = $tabsWrapper.find('> .tab-content'); //data-content-for
        var currentBreakpoint = getCurrentBreakpoint();

        $self.on('cca:set-wrapper-height', function(){
            var tallest = 0;
            $tabsWrapper.css('height', '');

            if(currentBreakpoint == 'desktop'){
                $.each($tabsContent, function (i, el) { 
                    var tabHeight = $(el).outerHeight(true);
                    if(tabHeight > tallest){
                        tallest = tabHeight;
                    }
                });
                $tabsWrapper.css('height', tallest + 'px');
            }
        });

        $(window).on('resize', function(){
            $self.trigger('cca:set-wrapper-height');
            if(currentBreakpoint !== getCurrentBreakpoint()){
                currentBreakpoint = getCurrentBreakpoint();
                reorderElementsForResponsive($tabsLi, $tabs, $tabsWrapper, currentBreakpoint);
                setSlidesToBeReInitialized($tabsContent);
                InitializeCards($self, $tabsContent.filter('.active'));
                $self.trigger('cca:set-wrapper-height');
            }
        });

        //on page load
        $self.trigger('cca:set-wrapper-height');
        InitializeCards($self, $tabsContent.filter('.active'));
        reorderElementsForResponsive($tabsLi, $tabs, $tabsWrapper, currentBreakpoint);

        $tabs.on('click', function(){
            var $activeTab = $(this);
            var activeIndex = $activeTab.attr('data-tab-index');
            var $activeTabContent = $tabsContent.filter('[data-content-for="'+activeIndex+'"]');

            $activeTab.addClass('active');
            $tabs.not($activeTab).removeClass('active');

            $activeTabContent.addClass('active');
            $tabsContent.not($activeTabContent).removeClass('active');

            InitializeCards($self, $activeTabContent);

            reorderElementsForResponsive($tabsLi, $tabs, $tabsWrapper, currentBreakpoint);
            scrollToSelectedTabPositionResponsive($tabs, currentBreakpoint);
        });

	});
});